import {Paper, Box, Typography, Button} from '@mui/material'
import {useNavigate, useLocation, Link} from 'react-router-dom'
import QRCode from 'react-qr-code'

export const MfaSetupPage = () => {
  const {state} = useLocation()
  const navigate = useNavigate()

  if (!state) {
    navigate('/auth/login', {
      replace: true,
    })
  }

  return (
    <Paper
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        overflow: 'hidden',
        width: '80vw',
        maxWidth: '30rem',
      }}
    >
      <Box
        sx={(theme) => ({
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          textAlign: 'center',
          textTransform: 'uppercase',
          p: theme.spacing(2),
        })}
      >
        <Typography
          component='h1'
          variant='h6'
          sx={{
            letterSpacing: '0.1em',
            fontWeight: '700',
          }}
        >
          Scan QR code with your preferred 2FA app.
        </Typography>
        <Typography variant='caption'>
          If you are on your mobile phone, tap{' '}
          <Box sx={{color: 'inherit'}} component='a' href={state.qrCode}>
            here
          </Box>
          .
        </Typography>
      </Box>
      <Box
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          padding: theme.spacing(5),
          [theme.breakpoints.down('md')]: {
            padding: theme.spacing(3),
          },
          [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
          },
        })}
      >
        <Box sx={{display: 'flex', justifyContent: 'center', mb: 5}}>
          <QRCode value={state.qrCode} />
        </Box>
        <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
          <Button
            type='button'
            variant='contained'
            color='primary'
            sx={(theme) => ({mr: theme.spacing(1)})}
            onClick={() => navigate(-1)}
            id='button-back'
          >
            Back
          </Button>
          <Button
            color='primary'
            variant='contained'
            sx={{
              position: 'relative',
            }}
            component={Link}
            to='/auth/mfa'
            state={state}
            id='button-continue'
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Paper>
  )
}

export default MfaSetupPage
